import classNames from "classnames";
import React, { useState } from "react";
import Popup from "reactjs-popup";

import pointsIcon from "../../../images/table-image/icon/points-icon.svg";

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onArchive?: (...args: any[]) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onDelete?: (...args: any[]) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onRename?: (...args: any[]) => any;
};

function QASectionPopupSettings({ onArchive, onDelete, onRename }: Props) {
  // State
  const [showPopup, setShowPopup] = useState(false);
  const [step, setStep] = useState(1);

  const triggerClasses = classNames("procedures-popup", "qa-popup", {
    active: showPopup,
  });

  function handleRename() {
    // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    onRename();
    setShowPopup(false);
  }

  function onOpen() {
    setShowPopup(true);
  }

  function onClose() {
    setShowPopup(false);
    setStep(1);
  }

  return (
    <Popup
      position="bottom left"
      trigger={
        <div className={triggerClasses} data-testid="qa-points-icon">
          <img src={pointsIcon} alt="points-icon" />
        </div>
      }
      open={showPopup}
      onOpen={onOpen}
      onClose={onClose}
      keepTooltipInside
    >
      <div className="qa-popup-settings">
        {step == 1 && (
          <div className="select-small-wrap">
            <ul>
              <li data-testid="rename-section-button" onClick={handleRename}>
                Rename
              </li>
              <li
                data-testid="delete-section-button"
                onClick={() => setStep(2)}
              >
                Delete Section
              </li>
              {/*
                <li data-testid='archive-section-button' onClick={ () => setStep(3) }>Archive Section</li> */}
            </ul>
          </div>
        )}
        {step == 2 && (
          <div className="table-dropdown">
            <h4>Delete Section</h4>
            <p>
              Do you want to delete this section? Any Test within will be
              permanently deleted.
            </p>
            <div className="confirmation">
              <button onClick={onDelete}>Yes</button>
              <button onClick={() => setShowPopup(false)}>No</button>
            </div>
          </div>
        )}
        {step == 3 && (
          <div className="table-dropdown">
            <h4>Archive Section</h4>
            <p>Do you want to archive this QA section?</p>
            <div className="confirmation">
              <button onClick={onArchive}>Yes</button>
              <button onClick={() => setShowPopup(false)}>No</button>
            </div>
          </div>
        )}
      </div>
    </Popup>
  );
}

export default QASectionPopupSettings;
